import { createLazyComponent } from '@muse-web/router'

export const AsyncHqStoragePaywallDialogContainer = createLazyComponent(
    () =>
        import(
            /* webpackChunkName: 'dialog-hq-storage-paywall' */ './HqStoragePaywallDialogContainer'
        ),
    'HqStoragePaywallDialogContainer',
)
